<template>
  <validation-observer ref="observer" v-slot="{ passes }">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ titulo }}
        </p>
      </header>
      <div class="modal-card-body">
        <section>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Nombre Terminal"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input v-model="model.nombre" type="text" />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Tipo Terminal"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-select
                v-model="model.tipoTerminal"
                placeholder="Seleccione una opción..."
              >
                <option value="Impresora">Impresora</option>
                <option value="LectorBarra">Lector c&oacute;digo barra</option>
              </b-select>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Dirección"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input v-model="model.direccion" type="text" />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Puerto"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input v-model="model.puerto" type="text" />
            </b-field>
          </validation-provider>
        </section>
      </div>
      <footer class="modal-card-foot">
        <div class="buttons">
          <b-button type="is-info" @click="passes(submit)">
            <span>Guardar</span>
          </b-button>
          <button class="button" @click="cerrarForm">
            <span>Salir</span>
          </button>
        </div>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

import { zonaService } from '@/services'

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})

export default {
  name: 'ZonaForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    titulo: {
      type: String,
      default: 'Agregar Registro'
    },
    modificacion: {
      type: Boolean,
      default: false
    },
    zona: {
      type: Object,
      required: true
    },
    objeto: {
      type: Object,
      required: false,
      default: () => this.modeloInicial
    }
  },
  data: () => ({
    model: null,
    cargando: false
  }),
  computed: {
    postModel() {
      return Object.assign(this.model, { zonaId: this.zona.id })
    }
  },
  created() {
    this.model = this.modeloInicial()
  },
  mounted() {
    this.model = Object.assign(this.model, this.objeto)
  },
  methods: {
    submit() {
      const self = this
      Promise.all([
        this.modificacion
          ? zonaService.updateTerminal(
              self.zona.id,
              self.objeto.id,
              self.postModel
            )
          : zonaService.addTerminal(self.zona.id, self.postModel)
      ])
        .then((rs) => {
          self.notificarAccionCompletada(
            `Se ${
              this.modificacion ? 'modificó' : 'agregó'
            } terminal correctamente`
          )
          self.$emit('close', true)
        })
        .catch((error) => self.procesarError(error))
    },
    cerrarForm() {
      this.$emit('close', false)
    },
    resetForm() {
      this.model = this.modeloInicial
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    modeloInicial() {
      return {
        id: null,
        nombre: null,
        tipoTerminal: null,
        direccion: null,
        puerto: 9100
      }
    }
  }
}
</script>
